import type { FaireProductEntity } from "../../entity_types/product";

export const p_hrpcrhrzwt: FaireProductEntity = {
  token: "p_hrpcrhrzwt",
  type: "product",
  name: "I ❤️ Smut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/39669a66687ec690589755a16cefe9caf3c3430b34dd743cb71a270b193152d2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/721a8055bd32ff3a1f36d0f29b2eb58491e9f9ddd9d0828384779ff40ab33c27.jpeg",
    "https://cdn.faire.com/fastly/f27d8962871c5d6ef0a4a5814cd5e37670cd71c221b910af4b634a4ad35fe339.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/5ce500f9f2d98deb05162c608248dc1327c4a3214816804644da90bce7cb32bf.jpeg"
  ],
  priceDollars: 6.75,
  description: "Reading is fun—especially when it's filthy! Keep your feet clean and comfy, and your mind as dirty as you want it while you wear these socks and dig into your favorite nasty lil book. 😝\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:11.708Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
